import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import Box from '@mui/material/Box';
import { AmbassadorItemContent } from './styles';
import { memo } from 'react';

const AmbassadorsGridItem = ({ item }) => {
  const { name, title, avatar, city, stateProvince, country, _meta } = item || {};
  const imgUrl = buildImageSrc(avatar, 300, 4, 5);
  const linkObj = buildLinkObj({ link: _meta?.deliveryKey });

  return (
    <Box
      component="a"
      rel={getRel(linkObj)}
      href={linkObj.href}
      display="flex"
      flexDirection="column"
      p={{ xs: 2, lg: 3 }}
      height="100%"
    >
      <LazyLoadImage
        imgComponent={
          /* eslint-disable-next-line @next/next/no-img-element */
          <img src={imgUrl} alt="Ambassador Profile" width="100%" />
        }
      />
      <AmbassadorItemContent p={2}>
        <h6 className="tw-font-bold tw-text-left tw-mb-4">{name}</h6>
        {title && (
          <p className="tw-text-left tw-mb-2 tw-text-action-600 tra-text-web-sub-2">{title}</p>
        )}
        {city && stateProvince && (
          <p className="tw-mb-0 tw-text-surface-500">
            {city}
            {city && stateProvince ? <>,&nbsp;</> : null}
            {stateProvince}
            {(city || stateProvince) && country ? <>,&nbsp;</> : null}
            {country}
          </p>
        )}
      </AmbassadorItemContent>
    </Box>
  );
};

export default memo(AmbassadorsGridItem);
